var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompGlasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "345.088px",
    height: "122.014px",
    viewBox: "0 0 345.088 122.014",
    enableBackground: "new 0 0 345.088 122.014",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.044,
    y: 18.841,
    fill: "#ACE5F9",
    width: 85.667,
    height: 78.667
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.157,
    y: 18.841,
    fill: "#ACE5F9",
    width: 85.667,
    height: 78.667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#327B9B",
    d: "M304.224,47.021V15.69c0-5.208-4.223-9.432-9.432-9.432h-92.055c-5.209,0-9.432,4.224-9.432,9.432v31.331 h-41.523V15.69c0-5.208-4.224-9.432-9.434-9.432H50.297c-5.21,0-9.434,4.224-9.434,9.432v31.331H12.102v26.62h28.762v31.331 c0,5.209,4.224,9.432,9.434,9.432h92.053c5.21,0,9.434-4.223,9.434-9.432v-31.33h41.522v31.331c0,5.209,4.223,9.432,9.433,9.432 h92.055c5.209,0,9.433-4.223,9.433-9.432V73.642h28.763v-26.62L304.224,47.021L304.224,47.021z M132.126,89.15 c0,3.363-2.726,6.09-6.089,6.09H66.611c-3.364,0-6.09-2.727-6.09-6.09V31.514c0-3.363,2.726-6.09,6.09-6.09h59.426 c3.363,0,6.089,2.727,6.089,6.09V89.15z M284.567,89.15c0,3.363-2.726,6.09-6.09,6.09h-59.427c-3.362,0-6.09-2.727-6.09-6.09 V31.514c0-3.363,2.728-6.09,6.09-6.09h59.427c3.364,0,6.09,2.727,6.09,6.09V89.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#408BB3",
    d: "M329.985,44.296h-28.25V13.522c0-5.115-4.146-9.264-9.264-9.264h-90.414 c-5.117,0-9.267,4.146-9.267,9.264v30.772h-40.498V13.522c0-5.115-4.147-9.264-9.265-9.264H52.616 c-5.117,0-9.265,4.146-9.265,9.264v30.772H15.102V70.44h28.25v30.772c0,5.116,4.147,9.265,9.265,9.265h90.414 c5.117,0,9.265-4.146,9.265-9.265V70.441h40.498v30.772c0,5.116,4.148,9.265,9.266,9.265h90.414c5.117,0,9.264-4.146,9.264-9.265 V70.441h28.25V44.296H329.985z M132.988,85.674c0,3.305-2.678,5.98-5.98,5.98H68.641c-3.305,0-5.981-2.678-5.981-5.98v-56.61 c0-3.303,2.677-5.979,5.981-5.979h58.367c3.303,0,5.98,2.679,5.98,5.979V85.674z M282.429,85.674c0,3.305-2.676,5.98-5.98,5.98 h-58.365c-3.305,0-5.979-2.678-5.979-5.98v-56.61c0-3.303,2.678-5.979,5.979-5.979h58.365c3.307,0,5.98,2.679,5.98,5.979V85.674z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#3B4A5D",
    cx: 97.099,
    cy: 59.384,
    r: 12.275
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B4A5D",
    cx: 247.991,
    cy: 59.384,
    r: 12.275
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode_1_"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompGlasses);
export default __webpack_public_path__ + "static/media/comp_glasses.0010977abf943170535c7004f9c6efe7.svg";
export { ForwardRef as ReactComponent };